<template>
  <nav>
    <div class="container-fixed">
      <h1>Normal Headline</h1>
      <h3>Normal Third Headline</h3>
      <p>Normal Text</p>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Normal (default activate first)</h1>
    </div>
    <div class="container-fixed">
      <VTabset label="Label">
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b">Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Fluid</h1>
    </div>
    <VTabset label="Label" grayed>
      <VTab label="Tab1" name="a2" active>Tab1</VTab>
      <VTab label="Tab2" name="b2">Tab2</VTab>
    </VTabset>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Normal without label</h1>
    </div>
    <div class="container-fixed">
      <VTabset>
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b" active>Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Normal with slim</h1>
    </div>
    <div class="container-fixed">
      <VTabset slim label="common.test_html">
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b" active>Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Normal with unselect</h1>
    </div>
    <div class="container-fixed">
      <VTabset unselect label="common.test_html" param="test2">
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b">Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Fluid without label</h1>
    </div>
    <VTabset grayed>
      <VTab label="Tab1" name="a2">Tab1</VTab>
      <VTab label="Tab2" name="b2">Tab2</VTab>
    </VTabset>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Normal with label as slot</h1>
    </div>
    <div class="container-fixed">
      <VTabset>
        <template #label>Label <small>with HTML</small></template>
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b" active>Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Fluid with label as slot</h1>
    </div>
    <VTabset grayed>
      <template #label>Label <small>with HTML</small></template>
      <VTab label="Tab1" name="a2" active>Tab1</VTab>
      <VTab label="Tab2" name="b2">Tab2</VTab>
    </VTabset>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>With HTML label</h1>
    </div>
    <div class="container-fixed">
      <VTabset label="Label <i>with HTML</i>">
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b" active>Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>With auto title</h1>
    </div>
    <div class="container-fixed">
      <VTabset label="Label <i>with HTML</i>">
        <VTab label="common.test_tab1" name="a" active>Tab1</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>With url and active</h1>
    </div>
    <div class="container-fixed">
      <VTabset label="Label" param="test">
        <VTab label="Tab A" name="name1">Tab1</VTab>
        <VTab label="Tab B" name="name2" active>Tab2</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>With url and auto active</h1>
    </div>
    <div class="container-fixed">
      <VTabset label="Label" param="test">
        <VTab label="Tab A" name="name1">Tab1</VTab>
        <VTab label="Tab B" name="name2">Tab2</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Buttons (default activate first)</h1>
    </div>
    <div class="container-fixed">
      <VTabset label="Label" buttons>
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b" title="individual title">Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Buttons with label as slot</h1>
    </div>
    <div class="container-fixed">
      <VTabset buttons>
        <template #label>Label via slot</template>
        <VTab label="Tab1" name="a">Tab1</VTab>
        <VTab label="Tab2" name="b" active>Tab2</VTab>
        <VTab label="Tab3" name="c">Tab3</VTab>
      </VTabset>
    </div>

    <hr class="offset-top-6" />

    <div class="container-fixed">
      <h1>Hide if only one (button layout)</h1>
    </div>
    <div class="container-fixed">
      <VTabset label="Label" buttons no-single-header>
        <VTab label="Tab1" name="a">Tab1</VTab>
      </VTabset>
    </div>
  </nav>
</template>

<script>
import VTabset from '../Tabset';
import VTab from '../Tab';
import { TEST_TABSET } from '@route-types';

export default {
  name: 'TabsetTest',

  components: {
    VTabset,
    VTab,
  },

  data() {
    return {
      TEST_TABSET,
    };
  },
};
</script>
